// Footer.jsx
import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import { trackWaitlistSignup } from "../analytics/googleAnalytics";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const [recipeEmail, setRecipeEmail] = useState("");
  const [recipeLoading, setRecipeLoading] = useState(false);
  const [recipeMessage, setRecipeMessage] = useState("");
  const [recipeSuccess, setRecipeSuccess] = useState(false);

  const handleRecipeSubmit = async (e) => {
    e.preventDefault();
    
    if (!recipeEmail.trim()) {
      setRecipeMessage("Por favor ingresa tu email");
      setRecipeSuccess(false);
      return;
    }

    setRecipeLoading(true);
    setRecipeMessage("");

    const API_URL = window.location.hostname === 'localhost' 
      ? 'http://127.0.0.1:8000/api'
      : 'https://api.wayoai.app/api';

    try {
      const response = await fetch(`${API_URL}/waitlist`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: recipeEmail.trim(),
          source: 'footer'
        })
      });

      const data = await response.json();

      if (response.ok) {
        setRecipeSuccess(true);
        setRecipeMessage("Perfecto. Revisa tu email para recibir la guía.");
        setRecipeEmail("");
        trackWaitlistSignup("footer_recipes");
      } else {
        setRecipeSuccess(false);
        setRecipeMessage(data.message || "Error al registrar el email. Inténtalo de nuevo.");
      }
    } catch (error) {
      setRecipeSuccess(false);
      setRecipeMessage("Error de conexión. Inténtalo de nuevo.");
    } finally {
      setRecipeLoading(false);
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        
        {/* Main footer content */}
        <div className="footer-content">
          
          {/* Brand section */}
          <div className="footer-brand">
            <div className="footer-logo">
              <img 
                src="/assets/img/wayo-logo.webp" 
                alt="Wayo" 
                className="footer-logo-img"
              />
            </div>
            <p className="footer-tagline">
              Apunta lo que comes con una foto. Calorías y macros en segundos, sin pesar nada.
            </p>
            <div className="footer-social">
              <a href="https://www.instagram.com/wayoai.app/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Links columns */}
          <div className="footer-links-grid">
            
            <div className="footer-column">
              <h4 className="footer-column-title">Producto</h4>
              <Link to="/#features">Funciones</Link>
              <Link to="/#benefits">Beneficios</Link>
              <Link to="/#recetas-gratis">Recetas gratis</Link>
              <Link to="/#faq">FAQ</Link>
              <Link to="/blog">Blog</Link>
            </div>

            <div className="footer-column" id="recetas-gratis">
              <h4 className="footer-column-title">Páginas útiles</h4>
              <Link to="/alternativa-myfitnesspal">Alternativa a MyFitnessPal</Link>
              <Link to="/app-para-contar-calorias-con-foto">Calorías con foto</Link>
              <Link to="/app-para-contar-macros">Contar macros</Link>
              <Link to="/coaches">Software para entrenadores</Link>
            </div>

            <div className="footer-column">
              <h4 className="footer-column-title">Soporte</h4>
              <Link to="/help">Centro de ayuda</Link>
              <Link to="/contact">Contacto</Link>
              <Link to="/privacy">Privacidad</Link>
              <Link to="/terms">Términos</Link>
              <Link to="/embajadores">Programa de Embajadores</Link>
            </div>

            <div className="footer-column">
              <h4 className="footer-column-title">Recetas gratis</h4>
              <p className="footer-newsletter-copy">
                Accede gratis a 50 recetas mediterráneas con calorías y macros.
              </p>
              
              {recipeMessage && (
                <div className={recipeSuccess ? 'newsletter-success newsletter-message' : 'newsletter-error newsletter-message'}>
                  {recipeMessage}
                </div>
              )}
              
              <form className="newsletter-form" onSubmit={handleRecipeSubmit}>
                <input 
                  type="email" 
                  placeholder="tu@email.com"
                  className="newsletter-input"
                  value={recipeEmail}
                  onChange={(e) => setRecipeEmail(e.target.value)}
                  disabled={recipeLoading}
                  required
                />
                <button 
                  type="submit" 
                  className="newsletter-button"
                  disabled={recipeLoading}
                >
                  {recipeLoading ? (
                    <>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{animation: 'spin 1s linear infinite'}}>
                        <circle cx="12" cy="12" r="10"></circle>
                        <path d="m4 12a8 8 0 0 1 8-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 0 1 4 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      Enviando...
                    </>
                  ) : (
                    "Recibir guía gratis"
                  )}
                </button>
              </form>
            </div>

          </div>

        </div>

        {/* Divider */}
        <div className="footer-divider"></div>

        {/* Bottom bar */}
        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} Wayo. Todos los derechos reservados.
          </p>
          <div className="footer-bottom-links">
            <Link to="/privacy">Privacidad</Link>
            <Link to="/terms">Términos</Link>
            <Link to="/cookies">Cookies</Link>
          </div>
        </div>

      </div>
    </footer>
  );
}
